export enum SalesforceFilterIds {
    BRAND = 'Store_Brand__c',
}
